$(function () {
	if ($('.jq_intersection').length) {
		$('html').addClass('io-active');

		var $items = $('.jq_intersection');

		var viewport = new IntersectionObserver(function(items, self) {
			$.each(items, function(i, item) {
				if (item.isIntersecting || item.intersectionRatio > 0) {
					$(item.target).addClass('io-in-view');

					self.unobserve(item.target);
				}
			});
		}, {
			rootMargin: '-20% 0%',
			threshold: .2
		});

		$items.each(function() {
			viewport.observe(this);
		});
	}
});
